import React, { useEffect, useState } from "react";
import DeckGL, { MapController, MVTLayer } from "deck.gl";
import { generateUrlGeoserverVector, hideLoading, showLoading } from "../core/utils";
import { DataFilterExtension } from "@deck.gl/extensions";
import { TileMapLayer2D } from "../singleLayer/renderLayerService";

export function DashboardDeckGL({
    region,
    setRegion
}) {
    const [viewState, setViewState] = useState({
        longitude: 105.64,
        latitude: -1.48,
        zoom: 4.6,
        pitch: 0,
        maxZoom: 17,
        minZoom: 4.6,
        bearing: 0
    })
    const [layer, setLayer] = useState([])
    const tooltipStyle = {
        backgroundColor: '#000b27',
        borderRadius: '20px',
        border: '4px #ffffff9c solid',
        boxShadow: '6px 0 16px 0 rgba(0, 0, 0, 0.08), 3px 0 6px -4px rgba(0, 0, 0, 0.12), 9px 0 28px 8px rgba(0, 0, 0, 0.05)'
    }

    function getTooltip({ object }) {
        return (
            object && {
                html: `\
                ${object.properties.NAME}\
      `,
                style: tooltipStyle
            }
        );
    }

    function clickHandler(info) {
        setRegion(info.object.properties.NAME)
    }

    useEffect(() => {
        const dataSource = generateUrlGeoserverVector("geodigital", "administrative-bounds-indonesia")
        const mapTheme = 'basic-v2/{z}/{x}/{y}@2x.png'

        setLayer([
            TileMapLayer2D(mapTheme),
            new MVTLayer({
                id: `sumatraDashboardAdminArea`,
                data: dataSource,
                onTileLoad: showLoading,
                onViewportLoad: hideLoading,
                uniqueIdProperty: 'GID',
                opacity: 1,
                stroked: true,
                filled: true,
                getFillColor: data => {
                    return data.properties.NAME === region ? [255, 182, 73, 90] : [0, 0, 0, 0]
                },
                getLineColor: [255, 121, 91],
                getFilterValue: d => {
                    return d.properties.level
                },
                updateTriggers: {
                    getFillColor: [region],
                    getLineColor: [region]
                },
                filterRange: [1, 1],
                extensions: [new DataFilterExtension({ filterSize: 1 })],
                getLineWidth: 1000,
                pickable: true,
                autoHighlight: true,
                highlightColor: [255, 182, 73, 90],
                onClick: (info) => clickHandler(info)
            }),
        ])
    }, [region])

    return (
        <div className="centerBox">
            <DeckGL
                controller={{ type: MapController }}
                initialViewState={viewState}
                getTooltip={getTooltip}
                layers={layer}
            >
            </DeckGL>

        </div>
    )
}